import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { MatTableDataSource, MatPaginator } from '@angular/material';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-attention-centers',
  templateUrl: './attention-centers.component.html',
  styleUrls: ['./attention-centers.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AttentionCentersComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  displayedColumns: string[] = ['name', 'municipality', 'address', /*'unit_type',*/ 'phone'];
  dataSource: MatTableDataSource<any>;
  municipalityControl = new FormControl('0');
  searchControl = new FormControl('');
  municipalities: any = [];
  centers: any = [];

  constructor(private dataService: DataService) { }

  ngOnInit() {
    const spanishRangeLabel = (page: number, pageSize: number, length: number) => {
      if (length === 0 || pageSize === 0) { return `0 de ${length}`; }
      length = Math.max(length, 0);
      const startIndex = page * pageSize;
      const endIndex = startIndex < length ?
        Math.min(startIndex + pageSize, length) :
        startIndex + pageSize;
      return `${startIndex + 1} - ${endIndex} de ${length}`;
    };

    this.paginator._intl.itemsPerPageLabel = 'Registros por página';
    this.paginator._intl.nextPageLabel = 'Siguiente';
    this.paginator._intl.previousPageLabel = 'Anterior';
    this.paginator._intl.lastPageLabel = 'Ultima página';
    this.paginator._intl.firstPageLabel = 'Primer página';
    this.paginator._intl.getRangeLabel = spanishRangeLabel;

    this.index();
  }

  index(): void {
    this.dataService.getMunicipalities().subscribe(municipalities => {
      this.municipalities = municipalities;

      this.dataService.getCenters().subscribe(centers => {
        this.centers = centers.map(center => {
          center.name = center.name.toLowerCase();
          center.municipality = (this.municipalities.filter(mun => mun.id === center.municipality_id));
          center.municipality = center.municipality && center.municipality[0] ? center.municipality[0].name : '';
          center.address = center.address.toLowerCase();
          center.neighborhood = center.neighborhood.toLowerCase();
          center.unit_type = center.unit_type.toLowerCase();
          return center;
        });

        this.dataSource = new MatTableDataSource(this.centers);
        this.dataSource.paginator = this.paginator;
        this.dataSource.filterPredicate = (data: any, filter: string) => {
          const filters = filter.split('@');
          return this.removeAccents(data.municipality).includes(filters[0]) &&
          ( this.removeAccents(data.name).includes(filters[1]) || this.removeAccents(data.address).includes(filters[1]) ||
          this.removeAccents(data.unit_type).includes(filters[1]) || this.removeAccents(data.phone).includes(filters[1]) );
        };
      });
    });
  }

  applyFilter(): void {
    let stringSearch = '';
    if (this.municipalityControl.value !== '0') {
      stringSearch = this.removeAccents((this.municipalities.filter(mun => mun.id === this.municipalityControl.value))[0].name);
    }
    stringSearch = stringSearch + '@' + this.removeAccents(this.searchControl.value);
    this.dataSource.filter = stringSearch;
  }

  private removeAccents(strAccents: any): string {
    strAccents = strAccents.trim().toLowerCase();
    strAccents = strAccents.split('');
    const strAccentsOut = new Array();
    const strAccentsLen = strAccents.length;
    const accents = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
    const accentsOut = 'AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz';

    for (let y = 0; y < strAccentsLen; y++) {
      if (accents.indexOf(strAccents[y]) !== -1) {
        strAccentsOut[y] = accentsOut.substr(accents.indexOf(strAccents[y]), 1);
      } else {
        strAccentsOut[y] = strAccents[y];
      }
    }

    return strAccentsOut.join('');
  }
}
